import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05a132fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-m-auto p-pt-6" }, "Crop Image", -1))
const _hoisted_2 = { class: "p-d-flex p-justify-center p-mb-4 btn-bg" }
const _hoisted_3 = { class: "p-d-flex p-justify-center p-flex-wrap p-grid flex-section" }
const _hoisted_4 = { class: "p-flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Crop image", -1))
const _hoisted_6 = { class: "p-flex-column" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign main page", -1))
const _hoisted_9 = {
  key: 0,
  class: "end"
}
const _hoisted_10 = { class: "p-flex-column" }
const _hoisted_11 = { class: "dashboard-view" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Dashboard", -1))
const _hoisted_14 = { class: "p-flex-column" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign managment", -1))
const _hoisted_17 = {
  key: 1,
  class: "end"
}
const _hoisted_18 = { class: "p-flex-column" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "User profile", -1))
const _hoisted_21 = { class: "p-flex-column" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "User logo", -1))
const _hoisted_24 = { class: "p-d-flex p-justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_cropper = _resolveComponent("cropper")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    closable: false,
    visible: $setup.show,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.show) = $event)),
    style: { width: '75vw' },
    modal: true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Button, {
          class: "cancel-button",
          label: "CANCEL",
          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('update:showCrop');})
        }),
        _createVNode(_component_Button, {
          class: "change-campaign-button",
          label: "Save changes",
          onClick: $setup.saveChanges
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.color = 'white')),
          label: "White background",
          class: "p-button-rounded p-button-secondary"
        }),
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.color = 'black')),
          label: "Black background",
          class: "p-button-rounded p-button-secondary"
        })
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_cropper, {
            ref: "cropper",
            class: _normalizeClass(["cropper bg-conf", { white : $setup.color === 'white', black: $setup.color === 'black' }]),
            "stencil-props": {
              aspectRatio: 4/3
            },
            onChange: $setup.cropMainImage,
            src: $props.image
          }, null, 8, ["class", "onChange", "src"]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: $setup.dataURL,
            alt: "crop image",
            class: "cropper"
          }, null, 8, _hoisted_7),
          _hoisted_8
        ]),
        (!$props.userView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    src: $setup.dataURL,
                    alt: "crop image"
                  }, null, 8, _hoisted_12)
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: $setup.dataURL,
                  alt: "crop",
                  class: "campaign-managment-view"
                }, null, 8, _hoisted_15),
                _hoisted_16
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: $setup.dataURL,
                  alt: "crop",
                  class: "user-dashboard-view"
                }, null, 8, _hoisted_19),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: $setup.dataURL,
                  alt: "crop",
                  class: "user-profile-view"
                }, null, 8, _hoisted_22),
                _hoisted_23
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}